import React, { useState, useContext, useEffect } from "react";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Uploader from "../components/playerphotos/UploaderPlayerPhotos";
import Wrapper from "../components/layout/Wrapper";
import CopyToClipboardButton from "../components/widgets/CopyToClipboardButton";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import useFlags from "../hooks/useFlags";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default function AllFlags({ parent }) {
   const [pageSize, setPageSize] = useState(100);
   const [pageSizeLibrary, setPageSizeLibrary] = useState(100);

   // USE HOOK
   const [
      fileList,
      {
         getFileList,
      },
   ] = useFlags();

   useEffect(() => {
      getFileList();
   }, []);

   const columns = [
      {
         field: "id",
         headerName: "Row ID",
         editable: false,
         width: 100,
         filterable: false,
         disableExport: true
      },
      {
         field: "code",
         headerName: "Code",
         editable: false,
         width: 350,
         renderCell: (params) => (
            <>
               {params.row.code}
            </>
         )
      },
      {
         field: "country",
         headerName: "Country",
         editable: false,
         width: 250
      },
      {
         field: "url",
         headerName: "Image Path",
         editable: false,
         width: 700,
         filterable: false,
         disableExport: true,
         renderCell: (params) => (
            <>
               <Button href={SERVER_URL + `/images/flags/${params.row.code}.png`} target="_new">OPEN</Button>
               {SERVER_URL + `/images/flags/${params.row.code}.png`}
            </>
         ),
      },
   ]

   return (
      <Wrapper>
         <Stack direction='row' spacing={2} alignItems='center' sx={{ mb: 2 }}>
            <Typography
               variant='h3'
               component='div'
               sx={{
                  whiteSpace: "nowrap",
                  textTransform: "uppercase",
               }}
            >
               All Flags
            </Typography>
         </Stack>

         <Box sx={{ height: 850, width: "100%" }}>
            {fileList && (
            <DataGrid
               disableColumnSelector
               disableDensitySelector
               density='compact'
               sx={{ backgroundColor: "#efefef" }}
               rowHeight={50}
               columns={columns}
               rows={fileList}
               pageSize={pageSize}
               onPageSizeChange={(newPageSize) =>
                  setPageSize(newPageSize)
               }
               rowsPerPageOptions={[20, 100]}
               components={{ Toolbar: GridToolbar }}
               componentsProps={{
                  toolbar: {
                     printOptions: {
                        disableToolbarButton: true,
                     },
                  },
               }}

               columnVisibilityModel={{ id: false }}
                  disableSelectionOnClick
               />
            )}
         </Box>
      </Wrapper>
   );
}
